import axios from "axios";
import {AppAdtopiaToken,
  AppPostCodeSingleApi,
  AppEmailValidateSingleApi,
  AppApiUrl,
  AppSinglePointPhoneValidationURL,AppEmailWebhookApi,
  } from "../Constants/EnvConstants";

require("dotenv").config();

export const Api = axios.create({
  baseURL: AppApiUrl,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken,
  },
});

export const CommonEndApi =  axios.create({
  baseURL : AppPostCodeSingleApi,
  timeout : 30000,
  headers : {
    "Content-Type" : "application/json",
    Accept : "application/json",
    Authorization : "Bearer " + AppAdtopiaToken
  }
});

export const CommonEmailValidateApiTimeDelay =  axios.create({
  baseURL : 'https://dev.app.leadfinery.com/api/emvs037/dev/v1',
  timeout : 3000,
  headers : {
    "Content-Type" : "application/json",
    Accept : "application/json",
    Authorization : "Bearer " + AppAdtopiaToken
  }
});

export const CommonEmailValidateApi =  axios.create({
  baseURL : AppEmailValidateSingleApi,
  timeout : 4000,
  headers : {
    "Content-Type" : "application/json",
    Accept : "application/json",
    Authorization : "Bearer " + AppAdtopiaToken
  }
});

export const IdUploadApi =  axios.create({
  baseURL: AppApiUrl,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + AppAdtopiaToken,
  },
});

export const CommonPhoneValidation =  axios.create({
  baseURL : AppSinglePointPhoneValidationURL,
  timeout : 30000,
  headers : {
    "Content-Type" : "application/json",
    Accept : "application/json",
    Authorization : "Bearer " + AppAdtopiaToken
  }
});

export const WebHookApi =  axios.create({
  baseURL : AppEmailWebhookApi,
  timeout : 30000,
  headers : {
    "Content-Type" : "application/json",
    Accept : "application/json",
  }
});